/**
 * Páginas que abrem sem evento escolhido (o App não manda para
 * /eventSelect): escolha de evento, 404, link público dos ingressos
 * (/:slug/ingressos/:orderId, resolve o evento pelo slug) e o Suporte (usa
 * os dados do cliente da loja).
 */
export const opensWithoutEvent = (pathname: string): boolean =>
  pathname.startsWith("/eventSelect") ||
  pathname.startsWith("/404") ||
  pathname.includes("/ingressos/") ||
  pathname === "/suporte" ||
  pathname.startsWith("/suporte/")
